/* eslint-disable */
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { POLEnvironmentConstants } from '../constants/pol-environment.constants';

@Injectable()
export class AttachHeaderInterceptor implements HttpInterceptor {
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (!req.headers.has('Content-Type') && !req.headers.has('enctype')) {
      req = req.clone({ setHeaders: { 'Content-Type': 'application/json' } });
    }
    if (!req.headers.has('Api-Key')) {
      req = req.clone({
        setHeaders: { 'Api-Key': POLEnvironmentConstants.apiKey }
      });
    }
    if (!req.headers.has('Ocp-Apim-Subscription-Key')) {
      req = req.clone({
        setHeaders: {
          'Ocp-Apim-Subscription-Key': POLEnvironmentConstants.subscriptionKey,
          'Ocp-Apim-Trace': 'true'
        }
      });
    }
    return next.handle(req);
  }
}
